/**
 * Translated Privacy Policy body.
 * Mirrors the English CMS HTML for page_id "privacy-policy".
 */

const frenchPrivacy = `
<div class="legal-page container">
      <h1>Politique de confidentialité</h1>
      <p class="last-updated"><em>Dernière mise à jour : octobre 2025</em></p>

      <p class="intro-text">
        Cranford Publications s'engage à protéger votre vie privée. Cette politique explique comment nous recueillons, utilisons, divulguons et protégeons vos renseignements lorsque vous visitez notre site ou passez une commande.
      </p>

      <h2>📋 Renseignements que nous recueillons</h2>
      <p>Nous recueillons les renseignements que vous nous fournissez directement, notamment :</p>
      <div class="info-box">
        <ul>
          <li><strong>Renseignements personnels :</strong> nom, adresse courriel, adresse postale, numéro de téléphone</li>
          <li><strong>Renseignements sur la commande :</strong> détails de paiement, adresse de livraison, historique d'achat</li>
          <li><strong>Données d'utilisation :</strong> témoins, adresse IP, type de navigateur, pages consultées</li>
        </ul>
      </div>

      <h2>🔍 Comment nous utilisons vos renseignements</h2>
      <p>Nous utilisons les renseignements recueillis aux fins suivantes :</p>
      <ul>
        <li>Traiter et expédier vos commandes</li>
        <li>Communiquer avec vous au sujet de votre commande ou de nos produits</li>
        <li>Améliorer notre site et notre service à la clientèle</li>
        <li>Envoyer des courriels promotionnels (avec votre consentement)</li>
        <li>Respecter nos obligations légales</li>
      </ul>

      <h2>🤝 Communication de vos renseignements</h2>
      <p>
        Nous ne vendons, n'échangeons ni ne louons vos renseignements personnels à des tiers. Nous pouvons les communiquer à des fournisseurs de services de confiance qui nous aident à exploiter le site, à mener nos activités ou à vous servir, à condition qu'ils s'engagent à en préserver la confidentialité.
      </p>
      <div class="highlight-box">
        <h3>Nos partenaires de confiance comprennent :</h3>
        <ul>
          <li><strong>Processeurs de paiement :</strong> pour le traitement sécurisé des transactions</li>
          <li><strong>Transporteurs :</strong> pour livrer vos commandes</li>
          <li><strong>Fournisseurs de courriel :</strong> pour les communications avec la clientèle</li>
        </ul>
      </div>

      <h2>🔒 Sécurité des données</h2>
      <p>
        Nous mettons en place des mesures techniques et organisationnelles appropriées pour protéger vos renseignements contre l'accès, la modification, la divulgation ou la destruction non autorisés. Aucune méthode de transmission sur Internet n'est toutefois sécurisée à 100&nbsp;%.
      </p>

      <h2>✅ Vos droits</h2>
      <div class="info-box">
        <p><strong>Vous avez le droit :</strong></p>
        <ul>
          <li>D'accéder aux renseignements personnels que nous détenons à votre sujet</li>
          <li>De demander la correction de renseignements inexacts ou incomplets</li>
          <li>De demander la suppression de vos renseignements personnels</li>
          <li>De vous retirer des communications marketing en tout temps</li>
          <li>De vous opposer au traitement de vos renseignements personnels</li>
        </ul>
      </div>

      <h2>🍪 Témoins</h2>
      <p>
        Nous utilisons des témoins et des technologies de suivi semblables pour améliorer votre navigation, analyser le trafic et comprendre d'où viennent nos visiteurs. Vous pouvez gérer les témoins dans les paramètres de votre navigateur.
      </p>

      <h2>📝 Modifications de cette politique</h2>
      <p>
        Nous pouvons mettre à jour cette politique de temps à autre. Nous vous en informerons en publiant la nouvelle version sur cette page et en mettant à jour la date de « Dernière mise à jour ».
      </p>
    </div>
`;

const germanPrivacy = `
<div class="legal-page container">
      <h1>Datenschutzrichtlinie</h1>
      <p class="last-updated"><em>Zuletzt aktualisiert: Oktober 2025</em></p>

      <p class="intro-text">
        Cranford Publications verpflichtet sich, Ihre Privatsphäre zu schützen. Diese Richtlinie erklärt, wie wir Ihre Daten erheben, nutzen, weitergeben und sichern, wenn Sie unsere Website besuchen oder bei uns bestellen.
      </p>

      <h2>📋 Welche Daten wir erheben</h2>
      <p>Wir erheben Daten, die Sie uns direkt mitteilen, darunter:</p>
      <div class="info-box">
        <ul>
          <li><strong>Personenbezogene Daten:</strong> Name, E-Mail-Adresse, Postanschrift, Telefonnummer</li>
          <li><strong>Bestelldaten:</strong> Zahlungsangaben, Lieferadresse, Kaufhistorie</li>
          <li><strong>Nutzungsdaten:</strong> Cookies, IP-Adresse, Browsertyp, besuchte Seiten</li>
        </ul>
      </div>

      <h2>🔍 Wie wir Ihre Daten nutzen</h2>
      <p>Wir nutzen die erhobenen Daten für folgende Zwecke:</p>
      <ul>
        <li>Zur Bearbeitung und Erfüllung Ihrer Bestellungen</li>
        <li>Zur Kommunikation zu Ihrer Bestellung oder unseren Produkten</li>
        <li>Zur Verbesserung von Website und Kundenservice</li>
        <li>Zum Versand von Werbe-E-Mails (mit Ihrer Einwilligung)</li>
        <li>Zur Erfüllung gesetzlicher Pflichten</li>
      </ul>

      <h2>🤝 Weitergabe Ihrer Daten</h2>
      <p>
        Wir verkaufen, tauschen oder vermieten Ihre personenbezogenen Daten nicht an Dritte. Wir können sie an vertrauenswürdige Dienstleister weitergeben, die uns beim Betrieb der Website, bei unserem Geschäft oder bei der Betreuung helfen, sofern sie sich zur Vertraulichkeit verpflichten.
      </p>
      <div class="highlight-box">
        <h3>Zu unseren Partnern gehören:</h3>
        <ul>
          <li><strong>Zahlungsdienstleister:</strong> für die sichere Transaktionsabwicklung</li>
          <li><strong>Versandunternehmen:</strong> zur Zustellung Ihrer Bestellungen</li>
          <li><strong>E-Mail-Dienstleister:</strong> für die Kundenkommunikation</li>
        </ul>
      </div>

      <h2>🔒 Datensicherheit</h2>
      <p>
        Wir setzen angemessene technische und organisatorische Maßnahmen ein, um Ihre Daten vor unbefugtem Zugriff, Änderung, Offenlegung oder Zerstörung zu schützen. Eine Übertragung über das Internet ist jedoch nie zu 100&nbsp;% sicher.
      </p>

      <h2>✅ Ihre Rechte</h2>
      <div class="info-box">
        <p><strong>Sie haben das Recht:</strong></p>
        <ul>
          <li>Auskunft über die zu Ihrer Person gespeicherten Daten zu erhalten</li>
          <li>Die Berichtigung unrichtiger oder unvollständiger Daten zu verlangen</li>
          <li>Die Löschung Ihrer personenbezogenen Daten zu verlangen</li>
          <li>Jederzeit dem Erhalt von Marketingmitteilungen zu widersprechen</li>
          <li>Der Verarbeitung Ihrer personenbezogenen Daten zu widersprechen</li>
        </ul>
      </div>

      <h2>🍪 Cookies</h2>
      <p>
        Wir verwenden Cookies und ähnliche Technologien, um Ihr Surferlebnis zu verbessern, den Besucherverkehr zu analysieren und zu verstehen, woher unsere Besucher kommen. Cookies können Sie in den Browsereinstellungen steuern.
      </p>

      <h2>📝 Änderungen dieser Richtlinie</h2>
      <p>
        Wir können diese Datenschutzrichtlinie von Zeit zu Zeit aktualisieren. Änderungen veröffentlichen wir auf dieser Seite und aktualisieren das Datum „Zuletzt aktualisiert“.
      </p>
    </div>
`;

export const PRIVACY_PAGE_TRANSLATIONS = {
  'fr-CA': {
    title: 'Politique de confidentialité',
    description:
      'Découvrez comment Cranford Publications protège vos renseignements personnels et respecte votre vie privée.',
    html: frenchPrivacy,
  },
  'fr-FR': {
    title: 'Politique de confidentialité',
    description:
      'Découvrez comment Cranford Publications protège vos informations personnelles et respecte votre vie privée.',
    html: frenchPrivacy,
  },
  de: {
    title: 'Datenschutzrichtlinie',
    description:
      'Erfahren Sie, wie Cranford Publications Ihre personenbezogenen Daten schützt und Ihre Privatsphäre achtet.',
    html: germanPrivacy,
  },
};
